// material-ui

import MainCard from "components/MainCard";
import "assets/css/buttonHover.css";
import { onPageChange } from "helper/paginationHelper";
import { SearchQueryFormatter } from "helper/searchHelper";

import { Button } from "@mui/material";
import {
  editButton,
  deactivateButton,
  activateButton,
  renderButton,
} from "components/actionButtons/actionsButtons";

import { Refresh2 } from "iconsax-react";
import { Table, Pagination, Spin } from "antd";
import { CSVLink } from "react-csv";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { AES, enc } from "crypto-js";
import * as url from "../../store/constant/Endpoints";
import {
  fetchAllVwwTrmsoitins,
  fetchTrmsCotntionDeletee,
} from "store/action/index";

import { dispatch } from "store/index";
import { useNavigate } from "react-router-dom";
import { TermsAndConditionsColumns } from "components/columns/columns";
// ==============================|| DASHBOARD - DEFAULT ||============================== //

const AllTermsAndCondition = ({ termsConditions }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(true);
  const [params, setparams] = useState({ page: 1 });

  // ----------------------------------------Permissions-----------------------------------------------
  let permissionUser = localStorage.getItem("logindata");
  let decryptedData = null;
  if (permissionUser) {
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
  }
  const permissions = JSON.parse(decryptedData);
  const allowedPermissions =
    permissions && permissions.length !== 0
      ? permissions.map((permission) => permission?.permission)
      : [];
  const permissionsAccessFunction = (brand) => {
    return (
      allowedPermissions &&
      allowedPermissions.length !== 0 &&
      allowedPermissions.some((permission) => permission.includes(brand))
    );
  };

  // ----------------------------------------Permissions-----------------------------------------------

  useEffect(() => {
    dispatch(
      fetchAllVwwTrmsoitins({
        params: SearchQueryFormatter(params),
        setLoading: setLoading,
      })
    );
  }, [params]);

  const handleEdit = (path, params) => {
    navigate("/domain-parameter/create-terms-and-condition", { state: params });
  };

  const handleUpdateStatus = (userId) => {
    dispatch(fetchTrmsCotntionDeletee({ id: userId, setLoading: setLoading }));

    dispatch(fetchAllVwwTrmsoitins({ setLoading: setLoading }));
  };

  const columns = TermsAndConditionsColumns({ params, setparams });
  columns.push({
    title: "Actions",
    key: "actions",
    render: (text, record) => {
      return (
        <span style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {allowedPermissions.includes(
            "domainParameter.terms_and_condition.edit"
          )
            ? editButton(
                "create-terms-and-condition",
                "/domain-parameter/create-terms-and-condition",
                record,
                handleEdit
              )
            : null}
          {allowedPermissions.includes(
            "domainParameter.terms_and_condition.delete"
          )
            ? record.status === 1
              ? deactivateButton("deactivate-tax", record, handleUpdateStatus)
              : activateButton("active-tax", record, handleUpdateStatus)
            : null}
        </span>
      );
      // return (
      // React.JSX.Element
      //   <span>
      //     {editButton(
      //       "create-terms-and-condition",
      //       "/domain-parameter/create-terms-and-condition",
      //       record,
      //       handleEdit
      //     )}
      //     {deactivateButton("deactivate-tax", record, handleUpdateStatus)}
      //   </span>
      // );
    },
  });

  return (
    <MainCard>
      <div style={{ textAlign: "end" }}>
        <Button
          sx={{ display: "initial" }}
          onClick={() => {
            setLoading(true);
            dispatch(fetchAllVwwTrmsoitins({ setLoading: setLoading }));
          }}
          size="medium"
          type="submit"
          variant="contained"
          color="primary"
          className="mx-3 refershButton active refreshButton"
        >
          <Refresh2
            className="refreshIcon"
            size="32"
            color="#ffffff"
            variant="TwoTone"
          />
        </Button>

        {allowedPermissions.includes(
          "domainParameter.terms_and_condition.create"
        )
          ? renderButton(
              "create-terms-and-condition",
              "/domain-parameter/create-terms-and-condition",
              "Add Terms and Conditions"
            )
          : null}
      </div>

      <Spin spinning={loading}>
        <Table
          className="border rounded"
          style={{ marginTop: 25, overflowX: "auto" }}
          dataSource={termsConditions?.data ?? []}
          columns={columns}
          rowKey="id"
          components={{
            body: {
              cell: ({ style, ...restProps }) => {
                return (
                  <td style={{ ...style, padding: "15px" }} {...restProps} />
                );
              },
            },
          }}
        />
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 25 }}
        >
          {/* <Pagination
            total={Number(lastPage ? lastPage : 1) * 10}
            defaultCurrent={params.page}
            onChange={(page) => onPageChange(setparams, params, page)}
          /> */}
        </div>
      </Spin>
    </MainCard>
  );
};
const mapStateToProps = (state) => {
  return {
    termsConditions: state.termsAlling.termsGetin,
  };
};

export default connect(mapStateToProps)(AllTermsAndCondition);
